// @ts-nocheck
/**
 * 非对称加密-RSA
 * 前端公钥加密 - 后端私钥解密
 */
import { JSEncrypt } from 'js-encrypt';
// 这里的公钥在Java端生成
//const PUBLIC_KEY =
// ('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+0NDZVsyp5UbOptXwQpnJ81S+l5Rb/p5pK3qr+APuz66eTeDWyTz3Pb922HGZpV2Ej7jqEr2baUBIq8+0VqfJi8IsNsZfkRn2YG+fV+hgJ5CZa7U7LlHfN5QrhvFaBqD+Egg0kzSg8JVtQl6GV3yrzlHEhUPKmVOd5TXoZIcqOwIDAQAB');
// 注：正常情况下私钥并不会记录在前端，这里使用私钥解密只是记录私钥解密方法
const PUBLIC_KEY =process.env.NEXT_PUBLIC_PUBLICKEY;
// const PRIVATE_KEY = '';
export default {
  RSAencrypt(pas) {
    // 实例化jsEncrypt对象
    const jse = new JSEncrypt();
    // 设置公钥
    jse.setPublicKey(PUBLIC_KEY);
    // console.log('加密：'+jse.encrypt(pas))
    return jse.encrypt(pas);
  },
  // 解密方法
  RSAdecrypt(pas) {
    const jse = new JSEncrypt();
    // 私钥
    jse.setPrivateKey(PUBLIC_KEY);
    // console.log('解密：'+jse.decrypt(pas))
    return jse.decrypt(pas);
  }
};
